import { useContext, useDeferredValue } from 'react';
import { TableCoreStateContext } from 'components/table/TableCoreStateContext';
import {
    Column,
    ColumnGraphSettings,
    ColumnVisualizationSettings,
    ReportDateRange,
} from 'types/domain';
import { FilterParams } from 'types/params';
import { SavedNextFilters } from 'types/request';

interface FetchQueryParams extends Omit<FilterParams, 'columns' | 'filters'> {
    columns: Column[];
    filters: SavedNextFilters;
    graph_settings: ColumnGraphSettings;
    display_settings: ColumnVisualizationSettings;
    date_range: ReportDateRange;
}

const useFetchQueryParams = (): FetchQueryParams | undefined => {
    const { params } = useContext(TableCoreStateContext);

    return useDeferredValue(params as FetchQueryParams);
};

export { useFetchQueryParams };
export type { FetchQueryParams };
